let onCompleted,
    languages = {
        name: 'languages',
        trigger: $('.js-trigger-languages'),
        elem: $('.js-target-languages'),
        active: false,
        overlay: false,
        disabled: false,
        allowScroll: true,
        callback: {
            show: function() {
                $('.js-languages').addClass('is-active');

                bLazy.revalidate();
            },
            hide: function() {
                $('.js-languages').removeClass('is-active');
            }
        }
    };

$(function() {
    for (const object of [languages]) {
        object.trigger.on('click', function(event) {
            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            }
            else {
                hideElem(object);
            }
        });
    }

    $('.js-target-languages > a').on('click', function() {
        hideElem(languages);
    });

    $('.js-newsletter-form').on("change", "input", function() {
        if (!$('.js-newsletter-form').valid()) {
            $('.js-newsletter-form').find(".captcha-wrapper").slideUp(250);
        }
    });

    $('.js-newsletter-form').on('submit', function(event) {
        event.preventDefault();
    });

    $('.js-form-subscription').validate({
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function (data) {
                    var msg = data.msg.format;
                    if (!msg) {
                        msg = data.msg;
                    }

                    if (!data.status) {
                        Eshop.alert(msg, { type: 'danger' });
                    } else {
                        Eshop.alert(msg);
                        $('form[name="subscription"] input').val('');
                    }
                }, 'json');
            });

            return false;
        }
    });
});
